import _ from 'lodash';
import api from '../../utils/service';
import { loadingCycle } from './page';
import { reloadCurrentUserData } from './auth';

const GET_ALL_ACCOUNTS_SUCCESS = 'redux/account/GET_ALL_ACCOUNTS_SUCCESS';
const GET_ALL_ACCOUNTS_FAIL = 'redux/account/GET_ALL_ACCOUNTS_FAIL';
const CREATE_ACCOUNT_SUCCESS = 'redux/account/CREATE_ACCOUNT_SUCCESS';
const CREATE_ACCOUNT_FAIL = 'redux/account/CREATE_ACCOUNT_FAIL';
const DELETE_ACCOUNT_SUCCESS = 'redux/account/DELETE_ACCOUNT_SUCCESS';
const DELETE_ACCOUNT_FAIL = 'redux/account/DELETE_ACCOUNT_FAIL';

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ALL_ACCOUNTS_SUCCESS:
      return {
        ...state,
        list: action.data,
      };
    case CREATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        details: action.data,
        error: null,
      };
    case DELETE_ACCOUNT_SUCCESS:
      return {
        ...state,
        list: _.get(action.data, 'savedAccounts'),
        error: null,
      };
    case GET_ALL_ACCOUNTS_FAIL:
    case CREATE_ACCOUNT_FAIL:
    case DELETE_ACCOUNT_FAIL:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}

export function getAllAccounts() {
  return (dispatch) =>
    api
      .get('/accounts')
      .then(({ data }) => dispatch(getAllAccountsSuccess(data)))
      .catch((error) => dispatch(getAllAccountsFail(error)));
}

export function getAllAccountsSuccess(data) {
  return {
    type: GET_ALL_ACCOUNTS_SUCCESS,
    data,
  };
}

export function getAllAccountsFail(error) {
  return {
    type: GET_ALL_ACCOUNTS_FAIL,
    error: _.get(error, 'response.data.message', _.get(error, 'message')),
  };
}

export function createAccount(data) {
  return (dispatch) =>
    loadingCycle(api.post('/accounts', data))
      .then(({ data }) => {
        dispatch(createAccountSuccess(data));
        return reloadCurrentUserData(dispatch);
      })
      .catch((error) => dispatch(createAccountFail(error)));
}

export function createAccountSuccess(data) {
  return {
    type: CREATE_ACCOUNT_SUCCESS,
    data,
  };
}

export function createAccountFail(error) {
  return {
    type: CREATE_ACCOUNT_FAIL,
    error: _.get(error, 'response.data.message', _.get(error, 'message')),
  };
}

export function deleteAccount(bankName) {
  return (dispatch) =>
    loadingCycle(api.delete(`/accounts?bankName=${encodeURIComponent(bankName)}`))
      .then(({ data }) => {
        dispatch(deleteAccountSuccess(data));
        return reloadCurrentUserData(dispatch);
      })
      .catch((error) => dispatch(deleteAccountFail(error)));
}

export function deleteAccountForUser(bankName, _id) {
  return (dispatch) =>
    loadingCycle(
      api.delete(
        `/accounts?bankName=${encodeURIComponent(bankName)}&user._id=${encodeURIComponent(_id)}`,
      ),
    )
      .then(({ data }) => dispatch(deleteAccountSuccess(data)))
      .catch((error) => dispatch(deleteAccountFail(error)));
}

export function deleteAccountSuccess(data) {
  return {
    type: DELETE_ACCOUNT_SUCCESS,
    data,
  };
}

export function deleteAccountFail(error) {
  return {
    type: DELETE_ACCOUNT_FAIL,
    error: _.get(error, 'response.data.message', _.get(error, 'message')),
  };
}
